// extracted by mini-css-extract-plugin
export default {"stock-promo__container":"styles_stock-promo__container__AfdIx"};